<template>
    <div class="view-main">
        <SectionHead />
        <FirstStep />
        <Kindergarten />
        <School />
        <TeenAge />
        <HighSchool />
        <!-- <ToBeContinued @click.native="$emit('openMenu')" /> -->
    </div>
</template>

<script>
import SectionHead from '@/components/sections/head'
import FirstStep from '@/components/sections/first-step'
import Kindergarten from '@/components/sections/kindergarten'
import School from '@/components/sections/school'
import TeenAge from '@/components/sections/teenage'
import HighSchool from '@/components/sections/highschool'
// import ToBeContinued from '@/components/blocks/to-be-continued'

export default {
    components: {
        SectionHead,
        FirstStep,
        Kindergarten,
        School,
        TeenAge,
        HighSchool
        // ToBeContinued
    },
    methods: {
    },
    mounted () {}
}
</script>

<style lang="stylus">
    .view-main {}
    .main-wrap {
        width 100%
        max-width $width-max
        margin 0 auto
        padding-left 1rem
        padding-right 1rem
    }
</style>
